import { FormFields } from './makeFormFields';

export default function validate(formFields: FormFields) {
  return {};
}
